import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './authService';
import { fetchNotifications, clearNotifications } from '../notification/notificationSlice';

const decodeToken = (raw) => {
	try {
		const token = JSON.parse(raw); // stored as JSON string
		const parts = token.split('.');
		if (parts.length < 2) return null;
		return JSON.parse(atob(parts[1]));
	} catch {
		return null;
	}
};
// Check if the user is authenticated

const saveUser = decodeToken(localStorage.getItem('token'));

export const signOut = createAsyncThunk('/signout', async (_, thunkAPI) => {
	await authService.signOut();
	localStorage.removeItem('logout');
	localStorage.setItem('logout', Date.now().toString());
	thunkAPI.dispatch(clearNotifications());
	return;
});

// Slice for User Login
export const signin = createAsyncThunk('/signin', async (loginData, thunkAPI) => {
	try {
		const response = await authService.signin(loginData);
		const locationId = response.auth?.locationId;
		localStorage.setItem('login', Date.now().toString());
		localStorage.removeItem('login');
		if (locationId) {
			thunkAPI.dispatch(fetchNotifications(locationId));
		}

		return response;
	} catch (error) {
		const message = error.response?.data?.message || error.message || error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting user Login
export const getUser = createAsyncThunk('/getUser', async (thunkAPI) => {
	try {
		const response = await authService.getUser();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const bootApp = createAsyncThunk('auth/boot', async (_, thunkAPI) => {
	const { auth } = thunkAPI.getState().auth;
	if (auth?.locationId) {
		await thunkAPI.dispatch(fetchNotifications(auth.locationId));
	}
});

const initialState = {
	auth: saveUser ? saveUser : null,
	user: null,
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		reset: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(signin.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(signin.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.auth = action.payload.auth;
			})
			.addCase(signin.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(signOut.fulfilled, (state) => {
				state.user = null;
				state.auth = null;
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
			})
			.addCase(getUser.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getUser.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.user = action.payload.User;
				state.isError = false;
			})
			.addCase(getUser.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = authSlice.actions;
export default authSlice.reducer;
